import { initAbout } from "./about";
import { initAdmin } from "./admin";
import { initGallery } from "./gallery";
import { initHome } from "./home";
import { initNav } from "./nav";
import { initNews } from "./news";
import { initOrder } from "./order";
import { setYear } from "./render";
import { initWork } from "./work";

const page = document.body.dataset.page ?? "";

setYear();
initNav();

const boot: Record<string, () => Promise<void>> = {
  home: initHome,
  about: initAbout,
  gallery: initGallery,
  work: initWork,
  news: initNews,
  order: initOrder,
  admin: initAdmin,
};

const start = boot[page];
if (start) {
  start().catch((error) => {
    console.error(error);
  });
}
